import { render } from "./journal-entries.vue?vue&type=template&id=21831176&scoped=true"
import script from "./journal-entries.vue?vue&type=script&lang=js"
export * from "./journal-entries.vue?vue&type=script&lang=js"

import "./journal-entries.vue?vue&type=style&index=0&id=21831176&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21831176"]])

export default __exports__